// Accès à la lib crypto Delo depuis le navigateur.
//
// Tout le chiffrement se fait ICI, côté client : le backend est aveugle, il ne
// relaie que des blobs déjà chiffrés (cf. docs/p1-architecture.md). Le module
// est le même code Rust que celui testé en natif — compilé pour wasm32 et
// exposant la même API (cf. packages/crypto/src/wasm.rs).
//
// Le module wasm pèse ~1,4 Mo (≈500 Ko sur le réseau) : on le charge une seule
// fois, à la demande, et jamais deux fois en parallèle.

import init, {
  MlsClient,
  MlsGroup,
  combineShares,
  decryptBlob,
  deriveKek,
  deriveSubkey,
  encryptBlob,
  generateMasterKey,
  generateX25519Keypair,
  masterKeyFingerprint,
  proveReconstitution,
  sealShare,
  splitSecret,
  shareIntegrityHash,
  unsealShare,
  unwrapMasterKey,
  verifyReconstitution,
  version,
  wrapMasterKey,
  x25519PublicKey,
} from '@delo/crypto/delo_crypto.js';
import wasmUrl from '@delo/crypto/delo_crypto_bg.wasm?url';

let loading: Promise<void> | null = null;

/**
 * Charge le module WebAssembly. Idempotent : les appels concurrents partagent
 * la même promesse. À attendre avant toute opération crypto.
 */
export function loadCrypto(): Promise<void> {
  loading ??= init({ module_or_path: wasmUrl }).then(() => undefined);
  return loading;
}

export {
  MlsClient,
  MlsGroup,
  combineShares,
  decryptBlob,
  deriveKek,
  deriveSubkey,
  encryptBlob,
  generateMasterKey,
  generateX25519Keypair,
  masterKeyFingerprint,
  proveReconstitution,
  sealShare,
  splitSecret,
  shareIntegrityHash,
  unsealShare,
  unwrapMasterKey,
  verifyReconstitution,
  version,
  wrapMasterKey,
  x25519PublicKey,
};
